/* eslint-disable prettier/prettier */
import * as React from "react";
import { Grid } from "@mui/material";

interface Props {}

const Terms: React.FC<Props> = (props: any) => {
  return (
    <div id="terms">
      <div
        className="userAdminInformation"
        style={{
          marginRight: "10px",
          position: "absolute",
          left: "120px",
        }}
      >
        <Grid container direction="row" className="adminHeader">
          <Grid item xs={12} md={6}>
            <h3>Terms & Conditions </h3>
          </Grid>
          <div className="divider"></div>
        </Grid>
        <div className="terms-container">
          <div className="terms-text">
            <main className="js-focus-hidden" id="MainContent" role="main">
              <div className="page-width">
                <div className="grid">
                  <div className="grid__item medium-up--five-sixths medium-up--push-one-twelfth">
                    <div className="section-header text-center">
                      <p>3.11.2025 v2.1</p>
                    </div>
                    <div className="rte">
                      <h2>
                        <b>Starfield Platform Access and Service Agreement</b>
                      </h2>
                      <p>
                        <strong>Last Updated: September 2025</strong>
                      </p>

                      <p>
                        This Provider Services Agreement only applies to users
                        of the North Dakota Pharmacy Service Corporation's
                        Starfield platform ("Platform") which includes practice
                        management and related services.
                      </p>

                      <p>
                        <b>This is a legally binding agreement between</b> the
                        North Dakota Pharmacy Service Corporation (Company, "we"
                        or "us") and you, as an individual provider of
                        healthcare services or authorized official on behalf of
                        a healthcare provider entity ("user" or "you"). By
                        accessing or using the Platform, you agree to be bound
                        by this Agreement.
                      </p>

                      <h3><b>Table of Contents</b></h3>
                      <ol>
                        <li>Scope and Definitions</li>
                        <li>Eligibility and Account Creation</li>
                        <li>Grant of Right to Use the Services</li>
                        <li>Access to the Services</li>
                        <li>HIPAA Compliance</li>
                        <li>Use of Information</li>
                        <li>User Conduct and Prohibited Activities</li>
                        <li>Intellectual Property Rights</li>
                        <li>Privacy and Data Protection</li>
                        <li>Termination and Suspension</li>
                        <li>Limitation of Liability</li>
                        <li>Indemnification</li>
                        <li>Governing Law</li>
                        <li>Modifications of Terms of Use</li>
                        <li>Independent Contractors</li>
                        <li>Miscellaneous Provisions</li>
                      </ol>

                      <h3>1. Scope and Definitions</h3>

                      <p>
                        <strong>1.1 Scope:</strong> This agreement governs access to
                        and use of the Platform and related services offered by
                        the Company. The Platform is designed to support
                        practice management and related service functions within
                        the scope of the user's professional operations.
                      </p>

                      <p>
                        <strong>1.2 Definitions:</strong>
                      </p>
                      <ul>
                        <li>
                          <strong>"Account"</strong> refers to the user's
                          registered account on the Platform.
                        </li>
                        <li>
                          <strong>"Clinical Data Exchange"</strong> means the
                          exchange, with your Consent, of protected health
                          information (and your personal information as
                          necessary) between you and HIPAA covered entities (and
                          their business associates) for any permitted purpose,
                          including, to the extent applicable, care
                          coordination, performance or quality programs, risk
                          adjustments, payment, other treatments or healthcare
                          operation purposes.
                        </li>
                        <li>
                          <strong>"Consent"</strong> means consent or
                          authorization by a user of the Platform or Services
                          allowing us to take actions under this Agreement,
                          which the user may give in an electronic communication
                          to us or by use of the features of the Platform (such
                          as share, transmit, refer, authorize, opt-in, agree,
                          selecting an action and the like). Such consent may
                          apply to an individual case, or may apply globally or
                          programmatically.
                        </li>
                        <li>
                          <strong>"Content"</strong> refers to any data,
                          information, text, images, or other materials
                          uploaded, downloaded, or created using the Platform.
                        </li>
                        <li>
                          <strong>"HIPAA"</strong> refers to the Health
                          Insurance Portability and Accountability Act of 1996
                          and its amendments.
                        </li>
                        <li>
                          <strong>"Personal Information"</strong> means the
                          information that includes an individual's name,
                          contact information, or identifiers that could be
                          anticipated to identify an individual personally.
                        </li>
                        <li>
                          <strong>"Provider Health Information"</strong> means
                          Protected Health Information that you or your entity
                          input or upload onto the Platform, or that we receive
                          on your behalf from authorized providers, your
                          patients or third-party partners pursuant to this
                          Agreement.
                        </li>
                        <li>
                          <strong>"Platform"</strong> refers to the Starfield
                          Platform owned and operated by the Company and all
                          related practice management and related services
                          provided through the Platform which includes software,
                          algorithms, apps, AI models, updates, modifications,
                          notifications or enhancements.
                        </li>
                        <li>
                          <strong>"User"</strong> or <strong>"You"</strong>{" "}
                          refers to any individual or entity accessing or using
                          the Platform.
                        </li>
                      </ul>

                      <h3><b>2. Eligibility and Account Creation</b></h3>

                      <p>
                        <strong>2.1 Eligibility:</strong> To be eligible to use
                        the Platform, the user must be a licensed healthcare
                        provider authorized to practice in North Dakota or any
                        other jurisdiction accepted by the Company.
                      </p>

                      <p>
                        <strong>2.2 Account Creation:</strong> Users must create
                        an Account on the Platform by providing accurate and
                        complete information as required. Users are responsible
                        for maintaining the confidentiality of their Account
                        credentials.
                      </p>

                      <p>
                        <strong>2.3 Account Responsibility:</strong> Users are
                        responsible for all activities that occur under their
                        Account. Company reserves the right to suspend or
                        terminate Accounts that are inactive or in breach of this
                        Agreement.
                      </p>

                      <h3><b>3. Grant of Right to Use the Service</b></h3>

                      <p>
                        <strong>3.1 Limited License:</strong> Company grants the
                        user a non-exclusive, non-transferable, revocable
                        license to access and use the Platform solely for the
                        user's related activities, subject to the terms and
                        conditions of this Agreement.
                      </p>

                      <p>
                        <strong>3.2 Restrictions:</strong> Users shall not
                        sublicense, sell, or distribute the Platform, nor engage
                        in any reverse engineering, decompiling, or disassemble
                        the Platform.
                      </p>

                      <h3><b>4. Access to the Service</b></h3>

                      <p>
                        <strong>4.1 Access:</strong> Users will have access to
                        the Platform, subject to any scheduled maintenance or
                        unexpected downtime. The Company will use reasonable
                        efforts to provide access without interruption.
                      </p>

                      <p>
                        <strong>4.2 Support:</strong> Company may provide
                        technical support to users in accordance with its
                        standard policies and procedures. Company will do its
                        best to provide support during normal business
                        operations (9:00-5:00 CST).
                      </p>

                      <p>
                        <strong>4.3 Verification:</strong> You agree that your
                        use of the Platform, or certain features and
                        functionality of the Platform, may be subject to
                        verification by us of your identity and credentials as a
                        healthcare provider or healthcare professional or a
                        healthcare entity and your ongoing qualifications as
                        such. You agree that we may use and disclose your
                        Personal Information for such purposes, including making
                        inquiry of third parties concerning identity and
                        professional and practice credentials. You authorize
                        such third parties to disclose to us such information as
                        we may request for such purposes, and you agree to hold
                        them and us harmless from any claim of liability arising
                        from the request for or disclosure of such information.
                      </p>

                      <p>
                        <strong>4.4 Support Information and Exchange:</strong>{" "}
                        We may provide information to assist you in clinical
                        decision-making. We may also provide reminders or
                        general healthcare related information and resources.
                        User agrees that the information and materials available
                        through the Platform are for informational and
                        educational purposes only and are not intended to
                        constitute professional medical advice, diagnosis or
                        treatment, or a substitute for your professional
                        judgement. You assume full risk and responsibility for
                        the use of information you obtain from or through the
                        Platform. We and our suppliers, licensors and others
                        disclaim all warranties, whether expressed or implied,
                        including any warranty as to the quality, accuracy, and
                        suitability of the information provided by the Platform
                        for any purpose.
                      </p>

                      <p>
                        <strong>4.5 Personal Health Record:</strong> User may
                        make available to your patients portions of their
                        medical records through the Platform that we operate on
                        your behalf. User is responsible for granting patient
                        access privileges to your patients, either on an
                        individual basis or for your entire patient population.
                        You are solely responsible for the information you make
                        available through the Platform. Health information
                        included in the Platform will be held and administered
                        by us on your behalf subject to the terms of this
                        Agreement and our business associate obligations.
                      </p>

                      <p>
                        <strong>4.6 Compliance with Law:</strong> You are
                        responsible for ensuring that your use of the Platform
                        complies with applicable law, including laws relating to
                        the maintenance of the privacy, security, and
                        confidentiality of patient and other health information.
                        We offer no assurance that your use of the Platform
                        under the terms of this Agreement will not violate any
                        law or regulation applicable to you. You acknowledge we
                        may share your information with third parties if we in
                        good faith disclose your information is necessary to (a)
                        comply with a court order, warrant, or other legal
                        proceeding; (b) protect the rights, property or safety
                        of others or the Company; (c) investigate or enforce
                        suspected breaches, or (d) allow third party partners to
                        comply with federal or state law.
                      </p>

                      <p>
                        <strong>4.7 Professional Responsibility:</strong> We
                        have no liability for the consequences to you or your
                        patients of your use of the Platform. You will be
                        responsible for the professional and technical services
                        you provide.
                      </p>

                      <h3>5. <b>HIPAA Compliance</b></h3>

                      <p>
                        <strong>5.1 Compliance:</strong> Users agree to comply
                        with all applicable HIPAA regulations in their use of
                        the Platform, including the protection of protected
                        health information ("PHI").
                      </p>

                      <h3><b>6. Use of Information</b></h3>

                      <p>
                        <strong>6.1 Permissions:</strong> Company will permit
                        access to Provider Health Information to users. Users
                        are responsible for ensuring the use of Provider Health
                        Information is consistent with the relevant legal
                        restrictions.
                      </p>
                      <p>
                        Company will permit access to user information by other
                        health care providers, HIPAA covered entities and their
                        business associates to whom you have Consented and who
                        have otherwise agreed to integrate with our Platform.
                      </p>
                      <p>
                        Company may disclose or permit access to user
                        information to entities such as, but not limited to,
                        health plans, clearinghouses, medical groups, and other
                        parties responsible for payment.
                      </p>

                      <p>
                        <strong>6.2 Authorization Granted:</strong> Company may
                        create data sets from Provider health information and
                        disclose them for any purpose in accordance with
                        applicable law and regulation. User hereby authorizes us
                        to enter into data use agreements on your behalf in
                        accordance with applicable law and regulation.
                      </p>
                      <p>
                        Company may use Your Information in order to prepare
                        analyses and reports the Platform makes available.
                        Reporting may include the use of data aggregation and
                        will be done in a manner permitted by law. Company may
                        use Your Information for the proper management and
                        administration of the Platform and to carry out our
                        legal obligations which may include disclosing
                        information to our business associate(s). Company may
                        permit access to the Platform by our contracted
                        developers under appropriate agreements.
                      </p>

                      <p>
                        <strong>6.3 Other uses:</strong> Company may use or
                        disclose Provider Health information for other purposes
                        provided that we will not make or permit any such use or
                        disclosure that would violate applicable law or
                        regulation.
                      </p>
                      <p>
                        The Company does not sell or distribute healthcare
                        information, but may utilize submitted health data for
                        surveys, research projects, performance, program
                        improvements, data collection or executing contract
                        requirements (payor or otherwise), that User is taking
                        part in or for general data analysis.
                      </p>

                      <p>
                        <strong>6.4</strong> Company may use Your Information to
                        provide you with notifications. Notifications are not a
                        substitute for a user's professional judgement
                        pertaining to any care you provide to any patient.
                      </p>

                      <p>
                        <strong>6.5 Misuse by Other Users:</strong> User
                        acknowledges that in granting access to the Platform,
                        Company will rely on the assurances of the recipients
                        of the information as to their identity and credentials
                        and the nature and purpose of use of the Platform. You
                        acknowledge that, while the Platform will contain
                        certain safeguards against misuse of the Platform,
                        Company will rely to a substantial extent on the
                        representation and undertakings of users of the
                        Platform. User agrees, you are solely responsible for
                        ensuring the Provider Health Information you share is
                        lawful.
                      </p>

                      <p>
                        <strong>6.6 Further Prohibitions:</strong> Users are
                        prohibited from providing any information about the
                        Platform, including screen capture, visuals or
                        descriptions of its functionality to non-Platform users
                        without the Company's consent.
                      </p>

                      <p>
                        <strong>6.7 Clinical Data Exchange:</strong> Company may
                        enable Clinical Data Exchange between user and your
                        business associate(s) or HIPAA covered entities or
                        Health Information Exchanges (HIE's/HIN's) and payers,
                        who desire to transmit data to you with respect to
                        patients they have a payment or treatment relationship
                        or with whom Consent has been obtained.
                      </p>

                      <h3><b>7. User Conduct and Prohibited Activities</b></h3>

                      <p>
                        <strong>7.1 Conduct:</strong> Users must use the
                        Platform in accordance with all applicable laws and
                        regulations. User shall not use the Platform to engage
                        in any lawful or unethical activities.
                      </p>

                      <p>
                        <strong>7.2 Prohibited Activities:</strong> Users shall
                        not…
                      </p>
                      <ul>
                        <li>
                          Use the Platform for any fraudulent, illegal or
                          misleading activities.
                        </li>
                        <li>Interfere with the operation of the Platform.</li>
                        <li>
                          Upload or transmit any viruses or malicious code or
                          spam.
                        </li>
                        <li>
                          Engage in any activity that could harm the Company's
                          reputation or business.
                        </li>
                        <li>
                          Infringe upon the intellectual property rights of
                          others.
                        </li>
                        <li>
                          Attempt to circumvent the Platform's security
                          measures.
                        </li>
                        <li>
                          Allow access to any party not authorized by NDPSC.
                        </li>
                        <li>
                          Transmit images or descriptions of product to any
                          party not authorized by NDPSC.
                        </li>
                      </ul>

                      <h3><b>8. Intellectual Property Rights</b></h3>

                      <p>
                        <strong>8.1</strong> The Platform, including its
                        software, algorithms, apps, and AI models, is the
                        intellectual property of the Company and can be
                        protected by copyright, patent, trademark or other
                        intellectual property laws.
                      </p>

                      <p>
                        <strong>8.2</strong> Users retain ownership of the
                        Content they create using the Platform but grant the
                        Company a worldwide, non-exclusive, royalty free, and
                        sublicensable license to use, reproduce, modify, adapt,
                        publish, translate, distribute, and display such Content
                        in connection with the Platform.
                      </p>

                      <p>
                        <strong>8.3</strong> Users must respect the intellectual
                        property rights when using the Platform and shall not
                        use third-party intellectual property without
                        permission.
                      </p>

                      <p>
                        <strong>8.4</strong> Users shall not use the Platform's
                        service marks, logos, or trademarks without the prior
                        written consent from the Company.
                      </p>

                      <h3><b>9. Privacy and Data Protection</b></h3>

                      <p>
                        <strong>9.1</strong> The Company collects and processes
                        personal data in accordance with its Privacy Policy,
                        which is incorporated into this agreement by reference.
                      </p>

                      <p>
                        <strong>9.2</strong> By using the Platform, you Consent
                        to the collection, use, and sharing of your data as
                        described in the Privacy Policy.
                      </p>

                      <p>
                        <strong>9.3</strong> The Company implements reasonable
                        security measures to protect user data but cannot
                        guarantee the absolute security of such data. The
                        Company will implement reasonable security measures to
                        protect the user's data, including PHI, from
                        unauthorized access or disclosure.
                      </p>

                      <h3><b>10. Termination and Suspension</b></h3>

                      <p>
                        <strong>10.1 De-Identified Information:</strong> In
                        consideration of our provision of the Platform, you
                        hereby transfer and assign to us all right, title and
                        interest in and to all de-identified information that we
                        make from Your Information. You agree the Company may
                        use, disclose, market, license and sell such information
                        for any purpose without restriction, and that you have
                        no interest in such information, or in the proceeds of
                        any sale, license or other commercialization thereof.
                      </p>

                      <p>
                        <strong>10.2 Termination by User:</strong> Users may
                        terminate this Agreement by providing written notice to
                        the Company and ceasing all use of the Platform.
                      </p>

                      <p>
                        <strong>10.3 Termination by Company:</strong> The
                        Company may terminate or suspend the User's access to
                        the Platform for any reason, including but not limited to
                        a breach of this Agreement.
                      </p>

                      <p>
                        <strong>10.4 Effect of Termination:</strong> Upon
                        termination, the User must cease all use of the
                        Platform, and the Company may delete the Provider's
                        Account and data, except as required by law.
                      </p>

                      <h3><b>11. Limitation of Liability</b></h3>

                      <p>
                        <strong>11.1 Limitations:</strong> To the maximum extent
                        permitted by law, Company shall not be liable for any
                        indirect, incidental, special, or consequential damages
                        arising out of or related to this Agreement or the use
                        of the Platform. The Platform is provided "as is" and
                        without warranties of any kind, express or implied. The
                        limitations of liability set forth in this section shall
                        not apply to damages resulting from the Company's gross
                        negligence or willful misconduct.
                      </p>

                      <p>
                        <strong>11.2 Cap on Liability:</strong> Company's total
                        liability under this Agreement shall not exceed the
                        amount paid by the User for the use of the Platform in
                        the twelve (12) months preceding the claim.
                      </p>

                      <h3><b>12. Indemnification</b></h3>

                      <p>
                        <strong>12.1 Indemnity:</strong> User agrees to
                        indemnify, defend, and hold harmless the Company, its
                        affiliates, and their respective officers, directors,
                        employees, and agents from and against any and all
                        claims, damages, liabilities and expenses arising out of
                        or in connection with use of the Platform or violations
                        of this Agreement.
                      </p>

                      <p>
                        <strong>12.2 User Notification:</strong> Users shall
                        promptly notify the Company of any claim subject to
                        indemnification and cooperate in the defense of such
                        claim(s).
                      </p>

                      <h3><b>13. Governing Law</b></h3>

                      <p>
                        <strong>13.1 Governed By:</strong> This Agreement shall
                        be governed by and construed in accordance with the laws
                        of the State of North Dakota, without regard to its
                        conflict of law principles.
                      </p>

                      <p>
                        <strong>13.2 Dispute Resolution:</strong> Any disputes
                        arising out of or related to the Agreement shall be
                        resolved through binding arbitration or class action in
                        North Dakota, except, where prohibited by law.
                      </p>

                      <h3><b>14. Modifications of Agreement of Use</b></h3>

                      <p>
                        <strong>14.1 Changes:</strong> The Company reserves the
                        right to modify this Agreement at any time, at its sole
                        discretion. Users will be notified of any material
                        changes to the Agreement via email or through a noticed
                        posted on the Platform. Continued use of the Platform
                        after the effective date of the modified Agreement
                        constitutes acceptance of the changes.
                      </p>

                      <p>
                        <strong>14.2 Force and Effect:</strong> If any provision
                        of this Agreement is found to be invalid or
                        unenforceable, the remaining provisions shall continue
                        in full force and effect.
                      </p>

                      <h3><b>15. Independent Contractors</b></h3>

                      <p>
                        <strong>15.1 Relationship:</strong> The parties to this
                        Agreement are independent contractors. There is no
                        relationship of partnership, joint venture, employment,
                        franchise or agency created hereby between the parties.
                        Neither party will have the power to bind the other or
                        incur obligations on the other party's behalf without
                        the other party's prior written consent.
                      </p>

                      <h3><b>16. Miscellaneous Provisions</b></h3>

                      <p>
                        <strong>16.1 Entire Agreement:</strong> This Agreement
                        constitutes the entire agreement between the parties
                        regarding the subject matter thereof and supersedes all
                        prior or contemporaneous agreements.
                      </p>

                      <p>
                        <strong>16.2 Severability:</strong> If any provision of
                        this Agreement is found to be invalid or unenforceable,
                        the remaining provisions shall remain in full force and
                        effect.
                      </p>

                      <p>
                        <strong>16.3 Waiver:</strong> No waiver of any provision
                        of this Agreement shall be effective unless in writing
                        and signed by both parties.
                      </p>

                      <p>
                        <strong>16.4 Assignment:</strong> Users may not assign
                        this Agreement without the prior written consent of the
                        Company. This Agreement may be assigned at the
                        discretion of the Company.
                      </p>

                      <p>
                        <strong>16.5 Notices:</strong> Any notices required or
                        permitted under this Agreement shall be in writing and
                        delivered to the respective parties at the addresses
                        provided in the Account or through the Platform.
                      </p>

                      <p>
                        <strong>16.6 Force Majeure:</strong> Company shall not
                        be liable for any delay or failure to perform due to
                        causes beyond its reasonable control, including acts of
                        God, war, terrorism, natural disasters, and labor
                        disputes.
                      </p>

                      <p>
                        <strong>16.7</strong> The Company reserves the right to
                        disclose information if necessary to comply with any
                        legal proceedings.
                      </p>

                      <p>
                        <strong>16.8 Cookies:</strong> The Company may use
                        "Cookies" to store information. Cookies are text files
                        stored on your computer which can retain small pieces of
                        information between visits. This way, your personal
                        preferences may be retained between visits. Most browser
                        software can be configured to refuse cookies or to
                        notify you when sites attempt to send you a cookie.
                      </p>

                      <p>
                        <strong>16.9 Third-Party Websites:</strong> As Company
                        does not control third party web services to which we
                        provide links, the collection and use of your personally
                        identifiable information by such web services shall be
                        subject to the policies and procedures of those
                        third-party web services.
                      </p>

                      <h3><b>Acknowledgment:</b></h3>
                      <p>
                        By using the Platform, you acknowledge that you have
                        read, understood and agree to be bound by this
                        Agreement.
                      </p>

                      <h3><b>CONTACT US:</b></h3>
                      <p>If you have any questions, please contact us at:</p>
                      <p>
                        North Dakota Pharmacy Service Corporation
                        <br />
                        1641 Capitol Way
                        <br />
                        Bismarck, ND 58501
                        <br />
                        701-258-4922
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
